import { Component, OnInit, ChangeDetectorRef, OnDestroy, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from '@app/service/message.service';
import { ByocMissionService } from '../../../service/mission.service';
import { ByocService } from '../../../../service/byoc.service';
import { ByocMissionStepListComponent } from '../byoc-mission-step-list/byoc-mission-step-list.component';

@Component({
    selector: 'app-byoc-mission-step-position',
    templateUrl: './byoc-mission-step-position.component.html',
    styleUrls: ['./byoc-mission-step-position.component.scss'],
    standalone: false
})
export class ByocMissionStepPositionComponent implements OnInit, OnDestroy {
    @ViewChild('list', { static: false, read: ByocMissionStepListComponent })
    list!: ByocMissionStepListComponent;

    loaded = false;
    loadedList = false;
    saving = false;

    private subscriptions: Subscription = new Subscription();

    constructor(
        private router: Router,
        private changeDetectorRef: ChangeDetectorRef,
        private translateService: TranslateService,
        private messageService: MessageService,
        private byocMissionService: ByocMissionService,
        private byocService: ByocService,
    ) {}

    ngOnInit() {
        this.loaded = true;
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    /**
     * Loaded Inner List
     */
    listLoaded($event: boolean) {
        this.loadedList = $event;
        this.changeDetectorRef.detectChanges();
    }

    cancelClick(): void {
        this.byocMissionService.close('btn-close');
    }

    backClick(): void {
        this.byocMissionService.step = 'course';
        this.changeDetectorRef.markForCheck();
    }

    saveClick(): void {
        // set as draft
        this.byocMissionService.form.patchValue({ status: 2 });

        // show loader
        this.saving = true;
        this.changeDetectorRef.detectChanges();

        // save as draft and redirect with message
        this.subscriptions.add(
            this.byocService.createMission(this.byocMissionService.form.getRawValue(), this.list.courses).subscribe((mission) => {
                this.messageService.setRouteMessage(
                    this.translateService.instant('v3-byoc-popup-create-mission-alert-created', { name: mission.name }),
                    'info',
                );
                if (!this.byocMissionService.isSubmodal) {
                    this.router.navigate(['/manager', 'settings', 'content', 'byoc', 'mission', mission.id]);
                }
                this.byocMissionService.close('btn-close');
            }),
        );
    }

    get missionName() {
        return this.byocMissionService.form.get('name')!.value;
    }
}
